import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  EditButton,
  DeleteButton,
  ReferenceField,
  ReferenceManyField,
  SingleFieldList,
  ChipField,
  RecordContext,
  ReferenceArrayInputContext,
  ReferenceArrayField,
} from "react-admin";
import CustomEmailField from "../CustomEmailField";

const UserList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="phoneNumber" />
      <CustomEmailField source="email" />
      <TextField label="Total Distance KM" source="totalDistanceKM" />
      <TextField label="Total Distance FT" source="totalDistanceFT" />
      <TextField label="Ama Coins" source="amaCoins" />
      <ReferenceField reference="tanks" source="currentTankId">
        <TextField label="Current Tank" source="name" />
      </ReferenceField>
      <EditButton basePath="/users" />
      <DeleteButton basePath="/users" />
    </Datagrid>
  </List>
);

export default UserList;
